export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";